// extracted by mini-css-extract-plugin
export default {"Intro":"Intro_Intro__ovoIH","i-left":"Intro_i-left__-r+nX","i-name":"Intro_i-name__Fax1k","type":"Intro_type__bqKwa","i-right":"Intro_i-right__oHLAY"};